import type { ReactNode } from 'react';

export const symbol_running_with_errors: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M825.5-235.63Q817-244.25 817-257v-267q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v267q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Zm1 139.15q-9.5-9.48-9.5-23.5t9.48-23.52q9.48-9.5 23.5-9.5t23.52 9.48q9.5 9.48 9.5 23.5t-9.48 23.52q-9.48 9.5-23.5 9.5t-23.52-9.48ZM478-80q-83 0-156-31.5T195-197q-54-54-85.5-127T78-480q0-83 31.5-156T195-763q54-54 127-85.5T478-880q80 0 152 30t129 87q9 9 9 21t-9 21L529-491q-14 14-32.5 6.34Q478-492.31 478-512v-308q-142 0-241 99t-99 241q0 142 98.81 241 98.82 99 241.19 99 67 0 128-25t111-70q9-8 21-8t20 9q8 9 8 21t-9 20q-57 54-129.24 83.5Q555.52-80 478-80Z"
		/>
	</svg>
);
